/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1TemplateConfigType } from '../models/V1TemplateConfigType';
import { HttpFile } from '../http/http';

export class V1SlackTemplateConfig {
    'id'?: string;
    'name'?: string;
    'type'?: V1TemplateConfigType;
    'routeId'?: string;
    'channelNames'?: Array<string>;
    'message'?: string;
    'conditional'?: Array<string>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "V1TemplateConfigType",
            "format": ""
        },
        {
            "name": "routeId",
            "baseName": "route_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "channelNames",
            "baseName": "channel_names",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "conditional",
            "baseName": "conditional",
            "type": "Array<string>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1SlackTemplateConfig.attributeTypeMap;
    }

    public constructor() {
    }
}

